import { queryKeyFactory } from "@l2r-front/l2r-query"

export const SPEEDINGS_ROOT_QUERY_KEY = "speedings"

export const speedingsQueryKeys = queryKeyFactory(SPEEDINGS_ROOT_QUERY_KEY, {
    layer: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "layer", filters],
    feature: (featureId, params = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "feature", featureId, params],
    project: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "project", filters],
    traffics: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "traffic", filters],
    grades: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "grades", filters],
    heavySpeedLimitsStats: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "heavySpeedLimitsStats", filters],
    lightSpeedLimitsStats: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "lightSpeedLimitsStats", filters],
    surveys: (filters = {}) => [SPEEDINGS_ROOT_QUERY_KEY, "surveys", filters],
})
